// @flow
import React from 'react';
import classNames from 'classnames/bind';
import nope from 'app/common/lib/nope';
import styles from './LinkButton.scss';


const cx = classNames.bind(styles);
type Props = {
  disabled?: boolean,
  primary?: boolean,
  onClick: (e: SyntheticEvent<HTMLElement>) => void,
  children: any,
  className?: string,
  name?: string,
};

const LinkButton = ({ disabled, primary, children, className, onClick, ...other }: Props) =>
  <a
    href="?"
    className={cx({ root: true, primary, disabled }, className)}
    onClick={disabled ? nope : onClick}
    {...other}
  >
    {children}
  </a>;

export default LinkButton;
